import { transformWidth } from '@/core/utils/convert';
import { Typography as MuiTypography } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
import { styled } from '../muiReexports';
export const TypographyStyled = styled(MuiTypography, shouldNotForwardProps('breakWordWidth', 'fontWeight', 'fontSize'))(({ theme, breakWordWidth, fontWeight, fontSize }) => ({
    overflowWrap: 'break-word',
    overflow: 'hidden',
    ...(fontWeight && {
        fontWeight: fontWeight === 'light'
            ? theme.typography.fontWeightLight
            : fontWeight === 'regular'
                ? theme.typography.fontWeightRegular
                : fontWeight === 'medium'
                    ? theme.typography.fontWeightMedium
                    : fontWeight === 'bold'
                        ? theme.typography.fontWeightBold
                        : 'inherit',
    }),
    ...(fontSize && {
        fontSize,
    }),
    ...(breakWordWidth && {
        width: transformWidth(breakWordWidth),
    }),
}));
